export default "__VITE_ASSET__C0gSMK_Z__"